export const ID = '01fd4e92-d4b7-437c-9700-2de6cb6dd2d8';

export const NAME = 'Embed iframe/HTML';
